import styled from 'styled-components';

import { TabPanel, hideScrollbar } from '@simplywallst/ui-core';
import type { Theme } from '@simplywallst/ui-core';

type SpacePx = keyof Theme & `x${number}spacePx`;

export const MonitoringPanelTabList = styled('div')`
  border-bottom: solid 1px ${({ theme }) => theme.color.whiteRGBA(0.1)};
`;

export const MonitoringPanelTabPanel = styled(TabPanel)<{
  paddingX?: SpacePx;
  paddingTop?: SpacePx;
  paddingBottom?: SpacePx;
}>`
  overflow-y: auto;

  ${({ theme, paddingX = 'x2spacePx', paddingTop, paddingBottom }) => `
    padding-left: ${theme[paddingX]}px;
    padding-right: ${theme[paddingX]}px;
    padding-top: ${paddingTop ? theme[paddingTop] : 0}px;
    padding-bottom: ${paddingBottom ? theme[paddingBottom] : theme.x7spacePx}px;

  `}
  ${hideScrollbar}
`;
